import React from 'react'

function UserDetail() {
  return (
    <div>
      
    </div>
  )
}

export default UserDetail
